
import {
  computed,
  defineComponent, ref, Ref, onMounted, watch,
} from 'vue';
import { useRoute } from 'vue-router';
import { useDriveStore } from '@/modules/drive/store/driveStore';
import AppHeader from '@/components/AppHeader.vue';
import AppLoader from '@/components/UI/AppLoader.vue';
import DriveService from '@/modules/drive/services/DriveService';
import { ICase, IMixedData, IResponse } from '@/types/interfaces';
import NotificationService from '@/services/NotificationService';
import MultipleSelectionPopUp from './BottomPopUp/PopUpTypes/MultipleSelectionPopUp.vue';
import MoveToPopUp from './BottomPopUp/PopUpTypes/MoveTo/MoveToPopUp.vue';
import SkeletonService from '@/services/SkeletonService';
import { MEDIA_TYPES, MIXED_DATA_TYPE } from '@/types/enums';
import AppQuestionPopUp from '@/components/AppQuestionPopUp.vue';

export default defineComponent({
  emits: ['close'],
  components: {
    AppHeader,
    AppLoader,
    MultipleSelectionPopUp,
    MoveToPopUp,
    AppQuestionPopUp,
  },
  setup(props, { emit }) {
    const driveStore = useDriveStore();
    const route = useRoute();

    const cases = computed<ICase[]>(() => (driveStore.search ? driveStore.searchCases : driveStore.cases.data));
    const bigLoader: Ref<string> = ref('');
    const isCaseSelected = computed(() => cases.value.filter((iCase) => iCase.selected).length);

    const showMultiSelection = ref(false);
    const isMoveToPopUp = ref(false);
    const isQuestionPopUp: Ref<boolean> = ref(false);

    // async function fetchData() {
    //   cases.value = driveStore.cases.data || [];
    // }

    function openQuestionPopUp() {
      showMultiSelection.value = false;
      isQuestionPopUp.value = true;
    }

    function deleteCases() {
      // bigLoader.value = 'Deleting cases...';
      const selectedCaseIds = cases.value.filter((iCase) => iCase.selected).map((iCase) => iCase.id!);

      DriveService.deleteBatchCases(selectedCaseIds).then(() => {
        //   driveStore.cases = cases.value.filter((iCase) => !iCase.selected);
        //   emit('close');
        // NotificationService.notifySuccess();
      });
      // }).finally(() => { bigLoader.value = ''; });
      const selected = cases.value.filter((iCase) => iCase.selected);
      driveStore.mixedData.data = driveStore.mixedData.data.filter((mix) => !selected.find((sel) => sel.id === mix.id));
      driveStore.cases.data = cases.value.filter((iCase) => !iCase.selected);
      driveStore.searchCases = driveStore.searchCases.filter((iCase) => !iCase.selected);
      emit('close');
    }

    function openMoveToPopUp() {
      showMultiSelection.value = false;
      isMoveToPopUp.value = true;
    }

    function setSkeletons(folderId: string | null, amount: number) {
      if (folderId) {
        SkeletonService.setFolderSkeletons(folderId, amount, MEDIA_TYPES.FILES);
      }
    }

    function removeSkeletons(folderId: string | null, amount: number) {
      if (folderId) {
        SkeletonService.removeFolderSkeletons(folderId, amount, MEDIA_TYPES.FILES);
      }
    }

    function toMixedData(selectedCases: ICase[]): IMixedData[] {
      return selectedCases.map((selCase) => ({
        id: selCase.id!,
        type: MIXED_DATA_TYPE.CASE,
        case: selCase,
      }));
    }

    function syncData(folderId: string | null = null, selectedCases: ICase[]) {
      if (folderId && driveStore.currentFolder?.id === folderId) {
        const hasItem = driveStore.currentFolder.mixedData?.find((mix) => mix.id === selectedCases[0].id);
        if (hasItem) {
          return;
        }
        const mixedData = toMixedData(selectedCases);
        driveStore.currentFolder.mixedData = [...mixedData, ...driveStore.currentFolder.mixedData!];
      }
    }

    function moveCases(folderId: string | null = null) {
      // bigLoader.value = 'Moving cases...';
      const selectedCases = cases.value.filter((iCase) => iCase.selected);
      const selectedCaseIds = selectedCases.map((iCase) => iCase.id!);

      const promises: Promise<IResponse>[] = [];

      selectedCaseIds.forEach((id) => {
        promises.push(DriveService.moveCase(id, folderId));
      });

      setSkeletons(folderId, selectedCaseIds.length);
      Promise.all(promises)
        .then(() => {
          syncData(folderId, selectedCases);
          NotificationService.notifySuccess();
        })
        .finally(() => { removeSkeletons(folderId, selectedCaseIds.length); });
      emit('close');
      showMultiSelection.value = false;
    }

    onMounted(() => {
      // fetchData();
    });

    watch(() => route.path, () => {
      driveStore.isCaseSelector = false;
    });

    return {
      driveStore,
      bigLoader,
      isCaseSelected,
      showMultiSelection,
      isMoveToPopUp,
      isQuestionPopUp,
      openMoveToPopUp,
      deleteCases,
      moveCases,
      openQuestionPopUp,
    };
  },
});
